import { useState, useRef } from "react";
import { Loader2, Upload, Plus } from "lucide-react";
import { api } from "../../lib/api";
import { PROJECT_DOCUMENT_ACCEPT, projectDocumentError } from "../../lib/projectDocuments";

export function AttachmentUploader({ projectId, onUploaded, compact }: { projectId: string; onUploaded: () => void; compact: boolean }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const fileInput = useRef<HTMLInputElement>(null);
  async function onPick(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const invalidDocument = projectDocumentError(file);
    if (invalidDocument) { setErr(invalidDocument); return; }
    setErr(null); setBusy(true);
    try {
      await api.uploadAttachment(projectId, file);
      onUploaded();
    } catch (e: any) { setErr(e?.message || "Upload failed."); }
    finally { setBusy(false); }
  }
  return (
    <div className={compact ? "flex flex-wrap items-center gap-2" : "border-2 border-dashed border-line rounded-lg p-4 text-center"}>
      <input ref={fileInput} type="file" accept={PROJECT_DOCUMENT_ACCEPT} className="hidden" onChange={onPick} disabled={busy} />
      <button type="button" disabled={busy} onClick={() => fileInput.current?.click()} className={`${compact ? "btn-outline" : "btn-navy"} inline-flex ${busy ? "opacity-70" : ""}`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : compact ? <Plus className="w-4 h-4" /> : <Upload className="w-4 h-4" />}{busy ? "Uploading…" : compact ? "Add document" : "Upload file"}
      </button>
      {!compact && <p className="text-xs text-mut mt-2">PDF or JPG, PNG, and WebP images · up to 25 MB</p>}
      {err && <p className="text-xs text-brand-red mt-1">{err}</p>}
    </div>
  );
}
